import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      const to = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(to);
    } catch (err) { toast.error(formatError(err)); } finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <PublicLayout>
      <section className="container-x py-24 max-w-md">
        <div className="overline mb-3">Log in</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Welcome back.</h1>
        <form onSubmit={onSubmit} className="mt-8 glass rounded-2xl p-8 space-y-4" data-testid="login-form">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
          <Field label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
          <button type="submit" disabled={loading} className="btn-neon w-full" data-testid="login-submit">{loading ? "..." : "Log in"}</button>
          <button type="button" onClick={google} className="btn-ghost w-full" data-testid="login-google">Continue with Google</button>
          <p className="text-sm text-ink-500 text-center">No account? <Link to="/register" className="text-gold">Sign up</Link></p>
        </form>
      </section>
    </PublicLayout>
  );
}

const Field = ({ label, value, onChange, type = "text", testid }) => (
  <label className="block">
    <div className="overline mb-2">{label}</div>
    <input type={type} value={value} required onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-lg bg-ink-900/[0.04] border border-ink-900/10 px-4 py-3 outline-none focus:border-neon" data-testid={testid} />
  </label>
);
